import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import { Integration } from "model/integration";
import { getUser } from "redux/selector";
import * as api from "api/api";
import { FacebookCard } from "./card";
import { FacebookModal } from "./modal";

interface Props {
	integration: Integration;
}

const Component: React.FC<Props> = ({ integration }) => {
	const user = useSelector((state: RootState) => getUser(state));
	const [modalOpen, setModalOpen] = useState(false);
	const [pageName, setPageName] = useState("");
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(false);

	useEffect(() => {
		const load = async () => {
			const selectedPageId = integration.data.facebookSelectedPageId as string;
			if (!selectedPageId) { setPageName("No page selected"); setLoading(false); return; }
			try {
				const response = await api.getFacebookPages();
				const page = response.pages.find(p => p.id === selectedPageId);
				setPageName(page ? page.name : "Page not found");
			} catch(_e) {
				setError(true);
				setPageName("Unable to load page");
			}
			setLoading(false);
		};
		load();
	}, [integration.data.facebookSelectedPageId]);

	const tokenExpiresAt = integration.data.tokenExpiresAt as string;
	let expirationText = "";
	if (tokenExpiresAt) {
		try { expirationText = new Date(tokenExpiresAt).toLocaleDateString(); } catch(_e) { expirationText = "Unknown"; }
	}

	return (
		<>
			<FacebookCard
				integration={integration}
				loading={loading}
				onViewIntegration={() => setModalOpen(true)}
			/>
			<FacebookModal
				open={modalOpen}
				onClose={() => setModalOpen(false)}
				integration={integration}
				agentLabel={user && user.agent ? user.agent.label : undefined}
				pageName={pageName}
				loading={loading}
				error={error}
				expirationText={expirationText}
			/>
		</>
	);
};

export const FacebookIntegration = Component;
